import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postData } from "../../utility/Utility";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";

function InsuranceLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false
  });
  const [loading, setLoading] = useState(false);

  // Check for saved credentials on component mount
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");

    if (savedEmail && savedPassword) {
      setFormData({
        email: savedEmail,
        password: savedPassword,
        rememberMe: true
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await postData("api/admin/login", {
        email: formData.email,
        password: formData.password
      });

      if (response?.success) {
        // Store token in localStorage
        localStorage.setItem("InsuranceAdminToken", response.token);

        // Handle remember me functionality
        if (formData.rememberMe) {
          localStorage.setItem("rememberedEmail", formData.email);
          localStorage.setItem("rememberedPassword", formData.password);
        } else {
          localStorage.removeItem("rememberedEmail");
          localStorage.removeItem("rememberedPassword");
        }

        toast.success("Login successful!");
        window.location.reload();
      } else {
        toast.error(response?.error || "Login failed. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="account-page">
        <div className="container-fluid p-0">
          <div className="row g-0 vh-100">
            <div className="col-xl-6">
              <div className="row">
                <div className="col-md-12 mx-auto log">
                  <div className="card card-border">
                    <div className="card-body">
                      <img
                        src="assets/images/insurance/logo-icon.png"
                        alt=""
                        className="top-bot"
                      />
                      <div className="mb-0 p-0 p-lg-3">
                        <div className="mb-0 border-0 p-md-4 p-lg-0 m-5">
                          <div className="p-0 text-lg-start text-center">
                            <div className="auth-brand">
                              <Link className="logo logo-dark" to="/">
                                <span className="logo-lg text-lg-center text-center">
                                  <h1>InsureSafe Admin</h1>
                                </span>
                              </Link>
                            </div>
                          </div>

                          <div className="auth-title-section mt-4 mb-4 text-lg-center text-center">
                            <h4 className="text-dark fw-semibold mb-3">
                              Welcome Back, Administrator
                            </h4>
                            <p className="text-muted">
                              Access the insurance management system
                            </p>
                          </div>

                          <div className="pt-0">
                            <form className="my-4" onSubmit={handleLogin}>
                              <div className="form-group mb-3">
                                <label htmlFor="email" className="form-label">
                                  Admin Email*
                                </label>
                                <input
                                  className="form-control"
                                  type="email"
                                  id="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="admin@insuresafe.com"
                                />
                              </div>

                              <div className="form-group mb-3">
                                <label htmlFor="password" className="form-label">
                                  Password*
                                </label>
                                <input
                                  className="form-control"
                                  type="password"
                                  id="password"
                                  name="password"
                                  value={formData.password}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter your password"
                                />
                              </div>

                              <div className="form-group d-flex mb-3">
                                <div className="col-sm-6">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="rememberMe"
                                      name="rememberMe"
                                      checked={formData.rememberMe}
                                      onChange={handleInputChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="rememberMe"
                                    >
                                      Remember me
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-6 text-end">
                                  <Link
                                    to="/forgot-password"
                                    className="text-muted fs-14"
                                  >
                                    Forgot password?
                                  </Link>
                                </div>
                              </div>

                              <div className="form-group mb-0 mt-3 row">
                                <div className="col-12 mt-5">
                                  <div className="d-grid">
                                    <button
                                      className="btn btn-primary fw-semibold"
                                      type="submit"
                                      disabled={loading}
                                    >
                                      {loading ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          Authenticating...
                                        </>
                                      ) : (
                                        "Login to Dashboard"
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 d-none d-xl-inline-block log-img-right insurance-bg">
              {/* Insurance-themed background image section */}
              <div className="insurance-bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsuranceLogin;